<a [routerLink]="[path]" [ngClass]="className" class="p-3 bg-white/60 dark:bg-white/10 shadow-sm flex justify-start gap-4 items-start dark:border-transparent rounded-3xl duration-200">
    <ng-content select=".moduleIcon"></ng-content>
    <div class="flex flex-col space-y-2">
        <span class="font-normal text-sm text-gray-700 dark:text-white duration-200">{{moduleName}}</span>
        <span class="font-bold text-lg text-[#102030] dark:text-white duration-200">{{moduleCount}}</span>
        <div class="flex items-center gap-2">
            <span *ngIf="percentageValue !== ''" class="text-xs font-semibold p-1 rounded-md duration-200" [ngClass]="trendBadgeClass">{{ trendDisplay }}</span>
            <span class="text-xs text-gray-500 dark:text-white duration-200">{{tagLabel}}</span>
        </div>
    </div>
</a>